import request from '@/request'
import config from '@/config'

export function getQueryParam(name) {
  const params = new URLSearchParams(window.location.search)
  return params.get(name)
}

export function getUserInfo(params = {}) {
  return request({
    url: `${config.apiBaseUrl}/cs/api/load`,
    method: 'get',
    params
  })
}

export function getConfig() {
  return Promise.resolve({
    svflag: 0,
    msg: 'success',
    data: {
      socketUrl: config.socketUrl,
      uploadImageUrl: config.uploadImageUrl
    }
  })
}
